export class DealerManager {
  constructor({
    id = 0,
    registeredCompanyName = null,
    tradingName = null,
    acn = null,
    abn = null,
    yrsEstablished = 0.0,
    address = null,
    city = null,
    state = null,
    postcode = 0,
    directorsName = null,
    driversLicense = null,
    dob = null,
    mobileNo = null,
    telephoneNo = null,
    faxNo = null,
    email = null,
    numberSubAgents = 0,
    accountName = null,
    bank = null,
    bsbno = null,
    branchAddress = null,
    accountNo = null,
    dealerId = 0,
    vpan = null,
    approvedDealer = false,
    dealerManagerId = 0,
    electronicSignature = null,
    produceRcti = false,
    commissionPercentage = 0.0,
    firstName = null,
    lastName = null
  } = {}) {
    this.id = id;
    this.registeredCompanyName = registeredCompanyName;
    this.tradingName = tradingName;
    this.acn = acn;
    this.abn = abn;
    this.yrsEstablished = yrsEstablished;
    this.address = address;
    this.city = city;
    this.state = state;
    this.postcode = postcode;
    this.directorsName = directorsName;
    this.driversLicense = driversLicense;
    this.dob = dob;
    this.mobileNo = mobileNo;
    this.telephoneNo = telephoneNo;
    this.faxNo = faxNo;
    this.email = email;
    this.numberSubAgents = numberSubAgents;
    this.accountName = accountName;
    this.bank = bank;
    this.bsbno = bsbno;
    this.branchAddress = branchAddress;
    this.accountNo = accountNo;
    this.dealerId = dealerId;
    this.vpan = vpan;
    this.approvedDealer = approvedDealer;
    this.dealerManagerId = dealerManagerId;
    this.electronicSignature = electronicSignature;
    this.produceRcti = produceRcti;
    this.commissionPercentage = commissionPercentage;
    this.firstName = firstName;
    this.lastName = lastName;
  }
}
export function createDealerManager(data) {
  return Object.freeze(new DealerManager(data));
}
